module.exports = __webpack_public_path__ + "img/inge_map.9d4568ea.svg";